import React from "react";
import PropTypes from "prop-types";
import  CheckedInItem  from "../CheckedInItem";
import styles from "./CheckedInList.module.css";

export function CheckedInList({ checkedIns }) {
  return (
    <div className={styles.checkedInList}>
      {checkedIns.map((checkedIn, index) => (
        <CheckedInItem
          key={index}
          date={checkedIn.date}
          time={checkedIn.time}
        />
      ))}
    </div>
  );
}

CheckedInList.propTypes = {
  checkedIns: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string.isRequired,
      time: PropTypes.string.isRequired,
    })
  ).isRequired,
};
